/**
 *
 * WidgetEmptyState
 *
 */

import React from "react"
import { loadTexts } from "../../utils/i18n"
import "./index.less"

function WidgetEmptyState(props) {
  const intlEmptyState = loadTexts("reports_general_view").reportAmbassador
    .engagementMeasurement.widgetListDimensions
  return (
    <div className="componentWidgetEmptyState">
      <span>{intlEmptyState.emptyStateTitle}</span>
      <p>{props.description}</p>
    </div>
  )
}

WidgetEmptyState.defaultProps = {
  title: "¡No cuentas con resultados!",
  // may be this will be obsoloted
  description:
    "No cuentas con resultados! Mostraremos aquí el resultado de mejores dimensiones una vez se supere el anonimato.",
}

export default WidgetEmptyState
